import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

import {
  FacturaCost,
  facturaCostsService,
} from "~/services/facturaCostsService";

/**
 * Fetches the weighted-average cost (WAC) per sales_request for the given ids,
 * so the Facturas report can show Costo / Margen / % alongside each invoice.
 * Returns a Map keyed by `sales_request_id`.
 */
export function useFacturaCosts(salesRequestIds: string[]) {
  const ids = useMemo(
    () => Array.from(new Set(salesRequestIds.filter(Boolean))).sort(),
    [salesRequestIds]
  );

  return useQuery<Map<string, FacturaCost>>({
    queryKey: ["factura-costs", ids],
    queryFn: () => facturaCostsService.getCostsBySalesRequest(ids),
    enabled: ids.length > 0,
    staleTime: 5 * 60 * 1000,
  });
}
